<div class="modal-header">
  <h4 class="modal-title text-danger">Error</h4>
</div>
<div class="modal-body">
  <p class="my-2">
    There was a problem with your request.
    <br>
    Please refresh this page or try again later.
  </p>
</div>